import React, { useRef } from 'react';
import { Box, useTheme } from '@mui/material';
import { type ResizeHandleAxis } from 'react-grid-layout';
import { Accordion, ReactGridContainer } from '@europrocurement/flexy-components';

type FormalistDashboardProps = {
    title: string;
    childrens: { key: string; component: React.ReactNode }[];
};

export type DashboardFiltersType = {
    startedAt: string;
    endedAt?: string;
};

const ComptaDashboard: React.FunctionComponent<FormalistDashboardProps> = function ({
    title,
    childrens,
}) {
    const { palette } = useTheme();

    const maxXindexCard = 5;
    const currentXIndexCard = useRef(-1);
    const currentYIndexCard = useRef(0);

    return (
        <Accordion
            title={title}
            expandLabel
            expanded
            expandColor={palette.primary}
            sx={{ boxShadow: 'unset', border: 'none' }}
            contentSxProps={{ gap: '16px', display: 'grid' }}
        >
            <ReactGridContainer
                localStorageName="grid-compta-user"
                gridconfig={{ cols: 5, rowHeight: 300 }}
                layoutProps={[
                    ...childrens.map((widget, i) => {
                        if (i !== 0 && i % maxXindexCard === 0) {
                            currentXIndexCard.current = -1;
                            currentYIndexCard.current++;
                        }
                        currentXIndexCard.current++;
                        return {
                            i: widget.key,
                            x: currentXIndexCard.current,
                            y: currentYIndexCard.current,
                            w: 1,
                            h: 1,
                            isResizable: true,
                            resizeHandles: [
                                's',
                                'w',
                                'e',
                                'n',
                                'sw',
                                'nw',
                                'se',
                                'ne',
                            ] as ResizeHandleAxis[],
                        };
                    }),
                ]}
            >
                {childrens &&
                    childrens.map((widget) => (
                        <Box key={widget!.key as string}>{widget.component}</Box>
                    ))}
            </ReactGridContainer>
        </Accordion>
    );
};

export default ComptaDashboard;
